import React from 'react'
import PartInjectionMouldingSettings from './partInjectionMouldingSettings'
import PartExtrutionSettings from './partExtrutionSettings'
import PartPunchPressSettings from "./partPunchPressSettings"
import PartCNCSettings from "./partCNCSettings"

const PartSetting = ({ name, partsData, form, filter, config }) => {
    const { templateType } = filter
    switch (templateType) {
        case 1:
            return <PartInjectionMouldingSettings name={name}
                form={form}
                partsData={partsData} config={config} />
        case 2:
            return <PartExtrutionSettings
                name={name}
                form={form}
                partsData={partsData} config={config} />
        case 3:
            return <PartPunchPressSettings
                name={name}
                form={form}
                partsData={partsData} config={config} />
        case 4:
            return <PartCNCSettings
                name={name}
                form={form}
                partsData={partsData} config={config} />
    }
}

export default PartSetting